import { useEffect, useState, useCallback } from "react";
import { useDealer } from "./useDealer";
import { transformArray } from "~/pages/ListOfDocuments/Modals/helper";
import { useTranslation } from "react-i18next";

interface useContractListIProps {
  filter?: string;
  type: string;
  page: string;
  count: string;
}

export const useDealersMetric = ({
  filter,
  type,
  page,
  count,
}: useContractListIProps) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getDealerMetrics } = useDealer();

  // const fetchData = async () => {
  //   setIsLoading(true);
  //   setError(null);
  //   try {
  //     const params = new URLSearchParams();
  //     params.append("page", page);
  //     params.append("count", count);
  //
  //     let res;
  //     if (type === "main") {
  //       res = await getDealerMetrics(`${params.toString()}&${filter}`);
  //     } else {
  //       // res = await getAdditionalList(params.toString());
  //     }
  //
  //     let formatData = [];
  //     if (res.data?.metrics) {
  //       formatData = transformArray({
  //         arr: res.data.metrics,
  //         arg: "metrics",
  //         filter,
  //       });
  //     }
  //     setData({ formatData, totalCount: res.data.total });
  //   } catch (error) {
  //     setError("Ошибка загрузки договоров.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("count", count);

      let res;

      if (type === "main") {
        res = await getDealerMetrics(`${params.toString()}&${filter}`);
      }

      let formatData = [];

      if (res.data?.metrics) {
        formatData = transformArray({
          arr: res.data.metrics,
          arg: "metrics",
          filter,
        });
      }

      setData({ formatData, totalCount: res.data.total });
    } catch (error) {
      setError(t("dealerMetrics.errorContract"));
    } finally {
      setIsLoading(false);
    }
  }, [filter, page, count, type, getDealerMetrics]);
  // useEffect(() => {
  //   if (filter && typeof filter === "string") {
  //     fetchData();
  //   }
  // }, [filter, page, count, type]);

  useEffect(() => {
    if (filter && typeof filter === "string") {
      fetchData();
    }
  }, [fetchData]);

  const refetch = () => {
    fetchData();
  };

  return { data, isLoading, error, refetch };
};
